var map = {
	"./denmark-1.jpg": 182,
	"./denmark-2.jpg": 183,
	"./denmark-3.jpg": 184,
	"./denmark-4.jpg": 185,
	"./denmark-5.jpg": 186,
	"./denmark-6.jpg": 187,
	"./denmark-7.jpg": 188,
	"./denmark-8.jpg": 189
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 181;